export const SIFT_MARKETING_SITE = 'https://www.justsift.com/';
export const ATTRIBUTE_PATH = '/attribute';
export const SKIP_TRANSLATE_FIELDS = ['displayName', 'firstName', 'lastName'];
export const SKIP_TRANSLATE_FIELD_NAMES = ['Display Name', 'First Name', 'Last Name'];
